import { RouteObject } from 'react-router-dom';
import Home from '@/views/pages/home';
import Dashboard from '@/views/pages/dashboard';
import AuthGuard from '@/router/guards/AuthGuard';
import AdminPanel from '@/views/layouts/admin-panel/AdminPanel';
import customerRoutes from './customers';
import userRoutes from './users';
import siteRoutes from './sites';
import deviceRoutes from './devices';
import locationRoutes from './locations';
import logsRoutes from './logs';
import accountRoutes from './account';

const routes: RouteObject[] = [
	{
		path: '',
		element: <AuthGuard element={<AdminPanel />} />,
		children: [
			{
				index: true,
				path: '',
				element: <Home />,
			},
			{
				path: 'dashboard',
				element: <Dashboard />,
			},
			...customerRoutes,
			...userRoutes,
			...siteRoutes,
			...deviceRoutes,
			...locationRoutes,
			...logsRoutes,
			...accountRoutes
		],
	},
];

export default routes;
